// @ts-check
import _ from 'lodash';
import useProductType from 'use/productTypes';
import useVendorDropdowns from 'use/vendors';
import store from 'store';
import { formatCurrency } from 'helpers';
import { ProductTypes } from 'enums';
import useCurrentUser from './currentUser';

export default function usePartNumberAutocomplete(props) {
    function featureFlagIsEnabled(flag) {
        return store.getters['revamp/systemSettings/featureFlagIsEnabled'](flag);
    }

    const { productTypeNamesByIdMap } = useProductType();
    const { vendors } = useVendorDropdowns();
    const { currentUser, currentUserIsFacility, currentUserIsAdmin } = useCurrentUser();

    function getVendorNameById(id) {
        if (!vendors.value) {
            return null;
        }
        const vendor = vendors.value.find((v) => v.id === id);
        return vendor ? vendor.name : null;
    }

    function getAdminLabelParts(product) {
        const vendorName = getVendorNameById(product.vendor_id);
        const manufacturerName = getVendorNameById(product.manufacturer_id);
        const productTypeName = productTypeNamesByIdMap.value.get(product.type_id);

        return _.filter(_.uniq([vendorName, manufacturerName, productTypeName]));
    }

    function getFacilityLabelParts(product) {
        const manufacturerName = getVendorNameById(product.manufacturer_id);
        return _.filter([manufacturerName]);
    }

    function processPartNumberLabel(data, value) {
        return data.map((product) => {
            let autocompleteParts = [];

            if (this.currentUserIsAdmin) {
                autocompleteParts = getAdminLabelParts(product);
            } else {
                autocompleteParts = getFacilityLabelParts(product);
            }

            product.autocompleteLabel = '<br>' + autocompleteParts.join(' - ');

            if (product.description) {
                product.autocompleteLabel += `<br />${product.description}`;
            }

            let shouldShowPrice =
                props.showPrice &&
                product.type_id !== ProductTypes.MANUAL &&
                featureFlagIsEnabled('FACILITY_PRODUCT_PRICE');

            shouldShowPrice =
                shouldShowPrice &&
                (currentUserIsAdmin.value ||
                    (currentUserIsFacility.value && currentUser.value.facility?.orderFormPriceDisabled === false));

            if (shouldShowPrice) {
                let price = product.facility_min_price || product.price;

                if (price && this.currentUserIsFacility) {
                    price = formatCurrency(price);
                    product.autocompleteLabel += `<br />Price: ${price}`;
                } else if (product.cost && this.currentUserIsAdmin) {
                    let cost = formatCurrency(product.cost);
                    product.autocompleteLabel += `<br />Cost: ${cost}`;
                }
            }

            return product;
        });
    }

    return {
        getAdminLabelParts,
        getFacilityLabelParts,
        processPartNumberLabel,
    };
}
